module.exports = __webpack_public_path__ + "img/business-woman.c952510.png";